<div class="content-layout" [brightsideWebFb]="{event_name: 'loans_intro'}">
  <bw-action-article-legacy>
    <div header-actions>
      <ui-nav-exit-back
        [trackingDetail]="{ event_name: 'loans_intro' }"
        [skipActionEmit]="false"
        (exitActionHandler)="goHome()"
      ></ui-nav-exit-back>
    </div>
    <div pre-title>
      <img src="../assets/loan-money-bags.png" width="134">
    </div>
    <div header-title>
      <div class="flex">
        <typography-legacy text-xsmall-regular color="var(--secondary-text)">
          {{ 'LOAN_INTRO_TITLE' | translate }}
        </typography-legacy>
        <typography-legacy title-large color="var(--primary-text)">
          {{ 'LOAN_INTRO_DESC' | translate }}
        </typography-legacy>
      </div>
    </div>
    <div content-section>
    <typography-legacy>
      {{ 'LOAN_INTRO_BODY' | translate }}
    </typography-legacy>
    </div>
    <div footer-actions>
      <button
        bw-button-legacy
        [brightsideWebFb]="{event_name: 'loans_intro'}"
        (click)="routeUser();">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>

  </bw-action-article-legacy>
</div>
